
import { GETCOLLECTIONSFULL_TYPES } from '../actions/getCollectionsFull'
import reducer, { defaultState } from './requests'
const Reducer = (state = defaultState, action) => {
    let requestReducer = reducer(GETCOLLECTIONSFULL_TYPES)(state, action)
    if (requestReducer !== null) return requestReducer
    switch (action.type) {
        default:
            return state
    }
}
export default Reducer